module.exports = __webpack_public_path__ + "img/paul-lomax.600efe3d.jpg";